/**
 * Belçika saati timezone ayarları
 */
const BELGIUM_TIMEZONE = 'Europe/Brussels';
const LOCALE = 'tr-TR';

/**
 * Tarihi Belçika saatine göre formatlar
 */
export const formatDateBelgium = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString(LOCALE, { 
    timeZone: BELGIUM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

/**
 * Saati Belçika saatine göre formatlar
 */
export const formatTimeBelgium = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  return dateObj.toLocaleTimeString(LOCALE, { 
    timeZone: BELGIUM_TIMEZONE,
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit'
  });
};

/**
 * Tarih ve saati Belçika saatine göre formatlar
 */
export const formatDateTimeBelgium = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const dateStr = dateObj.toLocaleDateString(LOCALE, {
    timeZone: BELGIUM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  const timeStr = dateObj.toLocaleTimeString(LOCALE, {
    timeZone: BELGIUM_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  
  return `${dateStr} ${timeStr}`;
};

/**
 * Şu anki Belçika saatini döndürür
 */
export const getCurrentTimeBelgium = (): Date => {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: BELGIUM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
  
  const parts = formatter.formatToParts(now);
  const year = parseInt(parts.find(p => p.type === 'year')?.value || '0');
  const month = parseInt(parts.find(p => p.type === 'month')?.value || '0') - 1;
  const day = parseInt(parts.find(p => p.type === 'day')?.value || '0');
  const hour = parseInt(parts.find(p => p.type === 'hour')?.value || '0');
  const minute = parseInt(parts.find(p => p.type === 'minute')?.value || '0');
  const second = parseInt(parts.find(p => p.type === 'second')?.value || '0');
  
  return new Date(year, month, day, hour, minute, second);
};

/**
 * Şu anki Belçika saatini string olarak döndürür
 */
export const getCurrentTimeBelgiumString = (): string => {
  const now = new Date();
  
  return now.toLocaleString(LOCALE, {
    timeZone: BELGIUM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit'
  });
};

/**
 * Tarihi gün/ay/yıl formatında formatlar (DD/MM/YYYY)
 */
export const formatDateDDMMYYYY = (dateString: string): string => {
  if (!dateString) return '';
  
  // YYYY-MM-DD formatındaki string'i parse et
  const date = new Date(dateString + 'T00:00:00');
  
  if (isNaN(date.getTime())) return dateString;
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Tarih aralığını gün/ay/yıl formatında formatlar
 */
export const formatDateRangeDDMMYYYY = (startDate: string, endDate: string): string => {
  return `${formatDateDDMMYYYY(startDate)} - ${formatDateDDMMYYYY(endDate)}`;
};


